<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M5 12H19"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M13 6L19 12L13 18"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
